module.exports = __webpack_public_path__ + "static/media/filezilla.40bfe119.svg";